import { dispatchDetailIbj } from '@core/utils/searcher';
import { SEARCH_IMG_QUERY_PARAMS } from '@core/constants/API';
import { updateFiltersStateHistoryPage } from '@core/utils/history-state';

/**
 * Handle the update reports button click
 * Updates filters state and dispatches detail object with AI page reset
 * @returns {void}
 */
export const handleUpdateReportsClick = () => {
    updateFiltersStateHistoryPage();

    dispatchDetailIbj({
        [SEARCH_IMG_QUERY_PARAMS.PAGE_AI]: 0,
    });
};
